import {
  type UserLoginRequest,
  userSchema,
  type User,
  type ChangePasswordRequest,
  type ForgotPasswordRequest,
} from '@/types/user.ts'
import { apiClient, authClient } from '@/api/http.ts'
const BaseApiUrl = import.meta.env.VITE_API_BASE_URL

const UserApi = {
  apiUrl: BaseApiUrl.replace(/\/*$/, ''),

  async login(loginRequest: UserLoginRequest): Promise<User> {
    const response = await authClient.post<unknown>(`${this.apiUrl}/login_check`, loginRequest)

    return userSchema.parse(response.data)
  },

  async logout(): Promise<boolean> {
    const response = await apiClient.get(`${this.apiUrl}/logout`)

    return response.status === 200
  },

  async refreshToken(): Promise<boolean | null> {
    const response = await authClient.get(`${this.apiUrl}/token/refresh`)

    return response.status === 301 || response.status === 302 ? null : response.status === 204
  },

  async changePassword(changePasswordRequest: ChangePasswordRequest): Promise<boolean> {
    const response = await apiClient.put(`${this.apiUrl}/reset_password`, changePasswordRequest)

    return response.status === 200
  },

  async forgotPassword(forgotPasswordRequest: ForgotPasswordRequest): Promise<boolean> {
    const response = await apiClient.put(`${this.apiUrl}/forgot_password`, forgotPasswordRequest)

    return response.status === 200
  },
}
export default UserApi
